import { Card, Col, Container, Row } from 'react-bootstrap'
import { useEffect } from 'react'
import AOS from 'aos'
import './Pharmas.css'


const Pharmas = () => {
    useEffect(() => {
        AOS.init({
            duration : 1500
        })
        AOS.refresh()
    }, [])

    return (
        <main className='pharmas'>
            <Container>
                <Row xs={1}>
                    <Col className='my-5'>
                        <Row className='justify-content-center align-items-center'>
                            <Col sm={'12'} md={'6'}>
                                <img data-aos='fade-down' src='./img/img5.jpg' className='img-fluid' alt='Foto 1' />
                            </Col>
                            <Col sm={'12'} md={'6'}>
                                <Card className='card1' data-aos='fade-left'>
                                     <p>
                                        El cuidado y la atención del Sector Farmacéutico es imprenscindible para 
                                        la correcta atención de la población. El estudio, control y seguimiento 
                                        es obligatorio, a la vez que esencial. TEFRIC ofrece un continuo servicio 
                                        de atención para garantizar el correcto estado de los medicamentos, 
                                        almacenes y trazabilidad, acorde a todas las normativas vigentes.
                                    </p>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default Pharmas